import { render } from "./release.vue?vue&type=template&id=8fca0d04&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=8fca0d04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fca0d04"

export default script